import { Directive, Input, OnInit, OnDestroy, HostListener, ElementRef, Renderer2, Inject, } from '@angular/core';
import { DOCUMENT } from '@angular/common';
 
@Directive({
  selector: '[appClickToToggle]',
  standalone: true,
})
export class ClickToToggleDirective implements OnInit, OnDestroy {
 
 
  @Input('appClickToToggle') set setKey2(v: string) { if (v) this.toggleKey = v; }
 
  @Input('afterToggle') afterToggleKey?: string;
  @Input('after-toggle') set setAfterToggle(v: string) { if (v) this.afterToggleKey = v; }
 
  toggleKey!: string;
 
  private grayBoxListeners: (() => void)[] = [];
 
  private static uiBooleans: Record<string, boolean> = {};
  private controllerEl: HTMLElement | null = null;
  private threeLineIconEl: HTMLElement | null = null;
 
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }
 
  ngOnInit(): void {
    if (!this.toggleKey) {
      console.warn('[appClickToToggle] toggleKey is required');
      return;
    }
 
    this.controllerEl = this.el.nativeElement.closest('.pageHeaderContainer') as HTMLElement ?? null;
 
    if (this.el.nativeElement.classList.contains('threeLineIcon')) {
      this.threeLineIconEl = this.el.nativeElement;
    }
 
    const grayBoxEls = Array.from(
      this.document.querySelectorAll<HTMLElement>('.grayBox.mobileOnly')
    );
    grayBoxEls.forEach((el) => {
      const unlisten = this.renderer.listen(el, 'click', () =>
        this.handleGrayBoxClick()
      );
      this.grayBoxListeners.push(unlisten);
    });
  }
 
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!this.toggleKey || !this.controllerEl) return;
 
    // Determine state based on whether the class is already present on the container
    const isActive = !this.controllerEl.classList.contains(this.toggleKey);
   
    ClickToToggleDirective.uiBooleans[this.toggleKey] = isActive;
 
    this.controllerEl.classList.toggle(this.toggleKey, isActive);
    this.el.nativeElement.closest('div')?.classList.toggle(this.toggleKey, isActive);
    this.renderer.setAttribute(this.el.nativeElement, 'aria-expanded', String(isActive));
 
    if (this.afterToggleKey) {
      const fn = this.resolveAfterToggle(this.afterToggleKey);
      if (fn) fn(isActive, event);
    }
  }
 
  private handleGrayBoxClick(): void {
    if (!this.controllerEl) return;
 
    const isVisible = this.controllerEl.classList.contains('bPhoneViewLinksVisible');
    const icon = this.threeLineIconEl;
   
    // Search within our local controller context for the link container
    const container = this.controllerEl.querySelector<HTMLElement>('#headerLinkContainer')
                   || this.controllerEl.querySelector<HTMLElement>('.headerLinkContainer');
                   
    const headerVisible = container
      ? getComputedStyle(container).visibility === 'visible'
      : false;
 
    if (isVisible && icon && headerVisible) {
      icon.click();
    }
  }
 
  private resolveAfterToggle(keyPath: string): ((isActive: boolean, e: Event) => void) | null {
    try {
      const parts = keyPath.split('.');
      let fn: any = window;
      for (const part of parts) fn = fn?.[part];
      return typeof fn === 'function' ? fn : null;
    } catch {
      return null;
    }
  }
 
  ngOnDestroy(): void {
    this.grayBoxListeners.forEach((fn) => fn());
    this.grayBoxListeners = [];
  }
}